
export default function SolutionSection() {
  const solutions = [
    {
      step: '01',
      title: 'STEP 1: 맞춤 분석',
      description: '당신의 연애 스타일과 목표를 정확히 파악하고, 일본 여성과의 소통에서 왜 잘 안 되는지 원인을 진단합니다.',
      features: ['원인 파악을 위한 철저한 상담', '상대의 본심 분석', '전략의 기반 마련'],
      image: 'https://static.readdy.ai/image/6b096200d48de7cb5be3c2123a55bd60/7f5d7a8213bc14e0b0d9b3039a743f9e.png'
    },
    {
      step: '02',
      title: 'STEP 2: 전략 설계',
      description: '일본 여성의 본심을 반영한 메시지·데이트 플랜을 함께 설계합니다.',
      features: ['행동 설계', '실천 계획', '실패를 피하기 위한 실시간 조언'],
      image: 'https://static.readdy.ai/image/6b096200d48de7cb5be3c2123a55bd60/1945e474924cfd5b52eb2b5f56486307.png'
    },
    {
      step: '03',
      title: 'STEP 3: 실행 & 피드백',
      description: '주 1회 미팅 + 24시간 피드백으로 실제 대화·행동을 첨삭하며, 성공률을 높여갑니다.',
      features: ['원하는 시간에 전화로 연애 코칭을 받다', '채팅으로 언제든지 상담 가능', '완벽한 연애 동행 지원 실현'],
      image: 'https://static.readdy.ai/image/6b096200d48de7cb5be3c2123a55bd60/d5306a82920080e3bf6b14c3f3a26000.png'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-blue-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            체계적인 3단계 해결방법
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            일본인여성의 <span className="text-blue-600 font-semibold">마음과 행동을 깊이 이해한 전문가들</span>이<br />
            당신에게 맞는 맞춤형전략을 설계하고 실행을 도와드립니다
          </p>
        </div>

        <div className="space-y-20">
          {solutions.map((solution, index) => (
            <div key={index} className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} items-center gap-12`}>
              <div className="lg:w-1/2">
                <div className="relative">
                  <div className="absolute -top-4 -left-4 w-16 h-16 bg-blue-600 text-white rounded-full flex items-center justify-center text-2xl font-bold">
                    {solution.step}
                  </div>
                  <div className="bg-white rounded-2xl p-8 shadow-lg">
                    <h3 className="text-3xl font-bold text-gray-900 mb-4">
                      {solution.title}
                    </h3>
                    <p className="text-lg text-gray-600 leading-relaxed mb-8">
                      {solution.description}
                    </p>
                    
                    <div className="space-y-3">
                      {solution.features.map((feature, featureIndex) => (
                        <div key={featureIndex} className="flex items-center">
                          <i className="ri-check-circle-fill text-green-500 text-xl mr-3"></i>
                          <span className="text-gray-700 font-medium">{feature}</span>
                        </div>
                      ))}
                    </div>
                    
                  </div>
                </div>
              </div>
              
              <div className="lg:w-1/2">
                <img 
                  src={solution.image}
                  alt={solution.title}
                  className="w-full h-80 object-cover object-top rounded-2xl shadow-lg"
                />
              </div>
            </div>
          ))}
        </div>

        <div className="mt-20 text-center">
          <div className="bg-gradient-to-r from-indigo-600 to-blue-700 rounded-2xl p-12 text-white">
            <h3 className="text-3xl font-bold mb-6">
              왜 저희방법이 효과적일까요?
            </h3>
            
            <div className="grid md:grid-cols-3 gap-8 mt-12">
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="w-16 h-16 mx-auto mb-4 bg-yellow-400 rounded-full flex items-center justify-center">
                  <i className="ri-user-heart-line text-2xl text-gray-900"></i>
                </div>
                <h4 className="text-xl font-bold mb-3">실제경험기반</h4>
                <p className="text-blue-100">
                  1000명이상의 일본인여성의 연애상담으로 축적된 실제 노하우
                </p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="w-16 h-16 mx-auto mb-4 bg-green-400 rounded-full flex items-center justify-center">
                  <i className="ri-global-line text-2xl text-gray-900"></i>
                </div>
                <h4 className="text-xl font-bold mb-3">국제연애전문</h4>
                <p className="text-blue-100">
                  한일연애를 직접 경험한 일본인여성 전문가들
                </p>
              </div>
              
              <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
                <div className="w-16 h-16 mx-auto mb-4 bg-pink-400 rounded-full flex items-center justify-center">
                  <i className="ri-time-line text-2xl text-gray-900"></i>
                </div>
                <h4 className="text-xl font-bold mb-3">지속적동반</h4>
                <p className="text-blue-100">
                  주1회미팅＋24시간채팅지원으로끝까지함께
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
